import Nullstack from 'nullstack';
export default function IconRuler2Off({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-ruler-2-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M12.03 7.97l4.97 -4.97l4 4l-5 5m-2 2l-7 7l-4 -4l7 -7"
  }), "   ", Nullstack.element("path", {
    d: "M16 7l-1.5 -1.5"
  }), "   ", Nullstack.element("path", {
    d: "M10 13l-1.5 -1.5"
  }), "   ", Nullstack.element("path", {
    d: "M7 16l-1.5 -1.5"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}